<template>
   <component class="image-card" :to="pageLink" :is="live ? NuxtLink : 'div'">
      <!-- background image -->
      <Image
         v-if="card.image"
         :image="card.image"
         :key="card.image"
         fit="cover"
      />

      <!-- tags -->
      <div class="tags">
         <!-- if saved -->
         <Tag
            v-if="savable"
            class="unsave action"
            role="button"
            @click.prevent="$emit('unsave')"
         >
            Unsave
         </Tag>

         <!-- search or related core work - show discipline -->
         <!-- v-if="$route.name == 'search' || $route.name == 'coreWork'"  -->
         <Tag class="discipline" :class="[discipline]">{{ discipline }}</Tag>
         <Tag class="upcoming" v-if="!live">Coming Soon</Tag>
      </div>

      <!-- text -->
      <div class="text">
         <h4 class="sans bold white">{{ card.title }}</h4>
         <p class="subtitle white">{{ card.sub_title }}</p>
         <!-- <p v-if="card?.teachable_count" class="meta white">
            {{ card.teachable_count }} Activities
         </p> -->
      </div>
   </component>
</template>

<script setup lang="ts">
const props = defineProps({
   card: {
      type: Object,
      required: true,
   },
   savable: {
      type: Boolean,
      required: false,
      default: false,
   },
});
defineEmits(["unsave"]);
const NuxtLink = resolveComponent("NuxtLink");
const card = toRef(props, "card");

// >> Computed Values
// Get Discipline
const discipline = computed(
   () =>
      props.card?.discipline?.slug ?? disciplineText(props.card.discipline_id)
);
// get published or not
const live = computed(() => card.value.status == "published");
// create the page link
// TODO:: Clean up this method and product wise standardize type
const pageLink = computed(() => {
   if (card.value.type == "core-work" || card.value.type == "core_works") {
      const discipline =
         card.value?.discipline?.slug ||
         disciplineText(card.value.discipline_id);

      return {
         name: "core-work",
         params: { discipline: discipline, slug: card.value.slug },
      };
   } else if (card.value.type == "planning-tool") {
      const discipline =
         card.value?.discipline?.slug ||
         disciplineText(card.value.discipline_id);

      return {
         name: "unit",
         params: { discipline: discipline, slug: card.value.slug },
      };
   } else if (card.value.type == "pd") {
      return `/pd/${card.value.slug}`;
   }
});
</script>

<style lang="scss">
@import "~/assets/scss/globals/image-card";
</style>
